import {Pipe, PipeTransform} from '@angular/core';
import {PreProductionStatus} from "@services";

@Pipe({
    name: 'preProductionStatus',
    standalone: true
})
export class PreProductionStatusPipe implements PipeTransform {
    transform(value: PreProductionStatus | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case PreProductionStatus.PoReceived: return "PO Received";
            case PreProductionStatus.Planning: return "Planning";
            case PreProductionStatus.Rejection: return "Rejection";
            case PreProductionStatus.NoStock: return "No Stock";
            case PreProductionStatus.ReleasedToHdc: return "Released to HDC";
            case PreProductionStatus.LateReleasedToHdc: return "Late Released to HDC";
            case PreProductionStatus.ReleasedToHdcSto: return "Released to HDC – STO";

            default: return value;
        }
    }
}

